module.exports = __webpack_public_path__ + "img/3.c7f78e14.jpg";